import * as Yup from 'yup';

import vehicleSchema from './vehicle';

const vehicleFormSchema = Yup.object({
  vehicle: vehicleSchema
});

export default vehicleFormSchema;
export type VehicleFormSchema = ReturnType<typeof vehicleFormSchema.cast>;
